import { fetchChapterPlates } from "src/models/tieup/novel/chapter/fetchChapterPlates"

// DBの図版リスト（章ごと）を取得
const getAllPlatesFromDB = async (
  novelId: number | null,
  chapterId: number | null,
) => {
  if (!novelId || !chapterId) return []

  const allPlates = await fetchChapterPlates({ novelId, chapterId }).catch(
    (error) => {
      // eslint-disable-next-line no-console
      console.error(error)

      return []
    },
  )

  return allPlates
}

export default getAllPlatesFromDB
